/* global bsBreakpoints */

(() => {
	const bsBreakpoint = bsBreakpoints.detectBreakpoint();
	const bannerTabletImg = document.querySelectorAll('[data-tablette-uri]') || null;
	const bannerMobileImg = document.querySelectorAll('[data-mobile-uri]') || null;

	if (bsBreakpoint === 'xSmall' && bannerMobileImg) {
		bannerMobileImg.forEach((banner) => {
			banner.style.backgroundImage = `url(
				${banner.getAttribute('data-mobile-uri')}
			)`;
		});
	} else if (bsBreakpoint === 'medium' && bannerTabletImg) {
		console.log('là');
		bannerTabletImg.forEach((banner) => {
			banner.style.backgroundImage = `url(
				${banner.getAttribute('data-tablette-uri')}
			)`;
		});
	}
})();
